import { RouteConfig } from 'vue-router'

const router: RouteConfig[] = [
  {
    path: '/myfolder',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: 'assignments/:id?',
        component: () => import('pages/MyFolder/Assignments.vue')
      },
      {
        path: 'journals/:id?',
        component: () => import('pages/MyFolder/Journals.vue')
      },
      { path: 'notebooks', component: () => import('pages/MyFolder/Notebooks.vue') },
      { path: 'portfolio', component: () => import('pages/MyFolder/Portfolio.vue') }
    ],
    meta: { requiresAuth: true }
  }
]

export default router
